/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function( ) {

	class SmartColorMapAPI {

		/**
		 * @function SmartColorMapAPI#setupColorMap
		 * @description gets smarts concepts, runs thru color map domain helpers and sets user color map in Fred Is Red
		 * @param {string} datasourceId
		 * @param {object} columnIds ColumnIds mappped to slots
		 * @return {Promise<boolean>} promise resolved with a boolean that indicates whether color map was set or not
		 */
		setupColorMap(){}
	}

	return SmartColorMapAPI;

});
